import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles'
import { TextField, Select, MenuItem, FormControl, InputLabel, Stack, Typography } from '@mui/material';
import { FILTER_TYPE, NUMBER_FILTER_TYPE } from '../../constants/filterType';
import ReportFilterFormValuesDb from './ReportFilterFormValuesDb';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg"
import DatePicker from "react-datepicker";
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns'



const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "50%"
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}))

export default function RenderFilterForm({ reportFilter, i, filterFormStateChange }) {
    const classes = useStyles();

    let filterOperation;
    let filterValue;
    const [textAreaState, setTextAreaState] = useState("")
    const [operator, setOperator] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [filterLimit, setFilterLimit] = useState("")

    const [maxStartDate, setMaxStartDate] = useState(Date.now())
    const [minEndDate, setMinEndDate] = useState(new Date("01/01/2021"))
    const [isSameDayStartTime, setIsSameDayStartTime] = useState(false)
    const [isSameDayEndTime, setIsSameDayEndTime] = useState(false)
    const [disabledProp, setDisabledProp] = useState(false)


    const handleChange = e => {
        const val = e?.target?.value
        setTextAreaState(val)
        let values = val ? val?.split('\n') : []
        filterFormStateChange("operatorvalues", i, values)
    }

    const handleFilterLimitChange = e => {
        const val = e?.target?.value;
        setFilterLimit(val)
        filterFormStateChange("operatorLimit", i, val)
    }
    const handleChangeStartDate = e => {
        let value = e
        if (moment(value).isValid()) {
            let edMonth, edDay, edYear, stMonth, stDay, stYear
            let currentDateVal = value;
            setMinEndDate(currentDateVal);
            setIsSameDayEndTime(true)
            if (endDate) {
                edMonth = new Date(endDate).getMonth()
                edDay = new Date(endDate).getDay()
                edYear = new Date(endDate).getFullYear()
                stMonth = new Date(currentDateVal).getMonth()
                stDay = new Date(currentDateVal).getDay()
                stYear = new Date(currentDateVal).getFullYear()


                if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
                    setIsSameDayStartTime(false)
                }
                else {
                    setIsSameDayStartTime(true)
                }
            }
            else {
                setIsSameDayEndTime(true)
            }
            value = moment(value).format("YYYY-MM-DD HH:mm:ss")
        }
        else {
            setIsSameDayEndTime(false)
            setMinEndDate(new Date("01/01/2021"))
        }
        setStartDate(value)
        filterFormStateChange("operatorvalues", i, [value, endDate])
    }

    const handleChangeDate = (value) => {
        // clear date
        if (value === null) {
            filterFormStateChange("operatorvalues", i, [])
            return
        }
        if (moment(value).isValid()) {
            filterFormStateChange("operatorvalues", i, [moment(value).format("YYYY-MM-DD HH:mm:ss")])
        }
    }

    const handleChangeEndDate = e => {
        let value = e
        if (moment(value).isValid()) {
            let edMonth, edDay, edYear, stMonth, stDay, stYear
            let currentDateVal = value;
            setMaxStartDate(currentDateVal)
            setIsSameDayStartTime(true)
            if (startDate) {
                edMonth = new Date(startDate).getMonth()
                edDay = new Date(startDate).getDay()
                edYear = new Date(startDate).getFullYear()
                stMonth = new Date(currentDateVal).getMonth()
                stDay = new Date(currentDateVal).getDay()
                stYear = new Date(currentDateVal).getFullYear()


                if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
                    setIsSameDayEndTime(false)
                }
                else {
                    setIsSameDayEndTime(true)
                }
            }
            else {
                setIsSameDayStartTime(true)
            }
            value = moment(value).format("YYYY-MM-DD HH:mm:ss")
        }
        else {
            setIsSameDayStartTime(false)
            setMaxStartDate(Date.now())
        }
        setEndDate(value)
        filterFormStateChange("operatorvalues", i, [startDate, value])
    }

    const handleChangeOperator = e => {
        let val = e?.target?.value
        setOperator(val)
        let useDbData = false;
        if (val === "equals#true") {
            val = val.split("#")[0];
            useDbData = true;
        }
        else if (val === "top" || val === "bottom") {
            useDbData = true;
        }
        filterFormStateChange("filterOperation", i, val, useDbData)
    }


    useEffect(() => {
        if (reportFilter?.operator === "equals" && reportFilter?.useDbData) {
            setOperator(reportFilter?.operator + "#true");
        }
        else if (reportFilter?.operator === "afterDate" || reportFilter?.operator === "beforeDate") {
            setOperator(reportFilter?.operator);
            if (reportFilter?.values?.length) {
                setStartDate(reportFilter.values[0]);
            } else {
                setStartDate("")
            }
        }
        else if (reportFilter?.operator === "inDateRange" || reportFilter?.operator === "notInDateRange") {
            if (reportFilter?.values?.length) {
                setStartDate(reportFilter.values[0]);
            }
            if (reportFilter?.values?.length > 1) {
                setEndDate(reportFilter.values[1]);
            }
            setOperator(reportFilter?.operator);
        }
        else if (reportFilter?.operator === "top" || reportFilter?.operator === "bottom") {
            setFilterLimit(reportFilter?.limit)
            setOperator(reportFilter?.operator);
        }
        else {
            setTextAreaState(reportFilter?.values?.join("\n"));
            setOperator(reportFilter?.operator);
        }
    }, [reportFilter.values])


    if (reportFilter?.type === "number" || reportFilter?.type === "count" || reportFilter?.dataSetType === "MEASURE") {
        filterOperation = (
            <>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Operation</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"filterOperation-" + i}
                    value={operator}
                    onChange={handleChangeOperator}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu`
                        }
                    }}
                >
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"equals"}>{NUMBER_FILTER_TYPE["equals"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"notEquals"}>{NUMBER_FILTER_TYPE["notEquals"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"gt"}>{NUMBER_FILTER_TYPE["gt"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"gte"}>{NUMBER_FILTER_TYPE["gte"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"lt"}>{NUMBER_FILTER_TYPE["lt"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"lte"}>{NUMBER_FILTER_TYPE["lte"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"set"}>{NUMBER_FILTER_TYPE["set"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"notSet"}>{NUMBER_FILTER_TYPE["notSet"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"top"}>{NUMBER_FILTER_TYPE["top"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value={"bottom"}>{NUMBER_FILTER_TYPE["bottom"]}</MenuItem>


                </Select>
            </>
        )
    } else if (reportFilter?.type === "string") {
        filterOperation = (
            <>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Operation</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"filterOperation-" + i}
                    value={operator}
                    onChange={handleChangeOperator}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu`
                        }
                    }}
                >
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="equals">{FILTER_TYPE["equals"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="equals#true">{FILTER_TYPE["equals#true"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="notEquals">{FILTER_TYPE["notEquals"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="contains">{FILTER_TYPE["contains"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="notContains">{FILTER_TYPE["notContains"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="set">{FILTER_TYPE["set"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="notSet">{FILTER_TYPE["notSet"]}</MenuItem>
                </Select>
            </>
        )
    } else if (reportFilter?.type === "time") {
        filterOperation = (
            <>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }}>Operation</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"filterOperation-" + i}
                    value={operator}
                    onChange={handleChangeOperator}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu`
                        }
                    }}
                >
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="inDateRange">{FILTER_TYPE["inDateRange"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="notInDateRange">{FILTER_TYPE["notInDateRange"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="beforeDate">{FILTER_TYPE["beforeDate"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="afterDate">{FILTER_TYPE["afterDate"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="set">{FILTER_TYPE["set"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="notSet">{FILTER_TYPE["notSet"]}</MenuItem>
                </Select>
            </>
        )
    }
    else {
        filterOperation = (
            <>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Operation</Typography>
                <Select
                    variant="outlined"
                    className="report_form_ui_input_select text-small pl-0"
                    id={"filterOperation-" + i}
                    value={operator}
                    onChange={handleChangeOperator}
                    size='small'
                    IconComponent={DropDownIcon}
                    MenuProps={{
                        classes: {
                            root: `form-select-menu`
                        }
                    }}
                >
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="equals">{FILTER_TYPE["equals"]}</MenuItem>
                    <MenuItem className={classes.menuDropdownItem + " menu-item-small"} value="notEquals">{FILTER_TYPE["notEquals"]}</MenuItem>
                </Select>
            </>
        )
    }

    if (operator === "equals#true") {
        filterValue = (
            <ReportFilterFormValuesDb filterCondtion={reportFilter} filterFormStateChange={filterFormStateChange} i={i} />
        )
    }
    else if (operator === "beforeDate" || operator === "afterDate") {
        filterValue = (
            <FormControl variant="outlined" className={classes.formControl}>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Select Date</Typography>

                <DatePicker showTimeSelect dateFormat="dd/MM/yyyy HH:mm:ss" className="report_form_ui_input_date"
                    selected={startDate ? moment(startDate).toDate() : null} onChange={handleChangeDate} isClearable />
            </FormControl>
        )
    }
    else if (operator === "inDateRange" || operator === "notInDateRange") {
        filterValue = (
            <FormControl variant="outlined" className={classes.formControl}>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Start Date</Typography>

                <DatePicker showTimeSelect dateFormat="dd/MM/yyyy HH:mm:ss" className="report_form_ui_input_date"
                    showYearDropdown={true}
                    showMonthDropdown={true}
                    dropdownMode="select"
                    selected={startDate ? new Date(startDate) : null} onChange={handleChangeStartDate} isClearable
                    minDate={new Date("01-01-2021 00:00:00")}
                    maxDate={maxStartDate}
                    minTime={new Date("2021-01-01 00:00:00")}
                    onKeyDown={(e) => {
                        e.preventDefault();
                    }}
                    onChangeRaw={(e) => e.preventDefault()}
                    maxTime={!isSameDayStartTime ? moment.utc().endOf('day') : maxStartDate}
                />
                <br />
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >End Date</Typography>

                <DatePicker showTimeSelect dateFormat="dd/MM/yyyy HH:mm:ss" className="report_form_ui_input_date"
                    showYearDropdown={true}
                    showMonthDropdown={true}
                    dropdownMode="select"
                    selected={endDate ? new Date(endDate) : null}
                    onChange={handleChangeEndDate} minDate={minEndDate}
                    maxDate={new Date()}
                    minTime={!isSameDayEndTime ? moment.utc().endOf('day') : setHours(setMinutes(new Date(), new Date(minEndDate).getMinutes()), new Date(minEndDate).getHours())}
                    maxTime={new Date().setHours(23, 59, 59, 999)}
                    isClearable
                    onKeyDown={(e) => {
                        e.preventDefault();
                    }}
                    onChangeRaw={(e) => e.preventDefault()}
                />

            </FormControl>
        )
    }
    else if (operator === 'top' || operator === 'bottom') {
        filterValue = (
            <FormControl variant="outlined" className={classes.formControl}>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Limit</Typography>
                <TextField
                    className="report_form_ui_input text-small"
                    id={"operatorvalues-" + i}
                    label=""
                    value={filterLimit}
                    onChange={handleFilterLimitChange}
                    variant="outlined"
                    size='small'
                />
            </FormControl>
        )
    }
    else {
        filterValue = (
            <FormControl variant="outlined" className={classes.formControl}>
                <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Value List</Typography>
                <TextField
                    className="report_form_ui_input text-small"
                    id={"operatorvalues-" + i}
                    label=""
                    multiline
                    maxRows={4}
                    value={textAreaState}
                    onChange={handleChange}
                    variant="outlined"
                    size='small'
                />
            </FormControl>
        )
    }


    return (<>
        <Stack width="100%" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            <FormControl> {filterOperation} </FormControl>
            {!(operator === "set" || operator === "notSet") ? (<>{filterValue}</>) : null}
        </Stack>
    </>)
}
